import SideNav from "./SideNav";
import TopBar from "./TopBar";
import { useState, useEffect, useContext } from "react";
import Swal from 'sweetalert2';
import axios from 'axios';
import {Link, useParams, useNavigate} from "react-router-dom";
import ReactPaginate from 'react-paginate';
import UserContext from './UserContext';

function SettingGameMainPackage(){

      const API_URL = process.env.REACT_APP_API_URL;

      const [isLoading, setIsLoading] = useState(true);
      const [loading, setLoading] = useState(false);
      const userContext = useContext(UserContext);

      const [error_list, setErrorList] = useState([]);
      const [searchQuery, setSearchQuery] = useState("");
      const [currentPage, setCurrentPage] = useState(0);
      const [perPage, setPerPage] = useState(25);

      const [games, setGames] = useState([]);
      const [package_name, setPackage_name] = useState("");
      const [description, setDescription] = useState("");
      const [selectedGame, setSelectedGame] = useState('');
      const [game_main_package, setGame_main_package] = useState([]);
      const [selectedGameLocation, setSelectedGameLocation] = useState('');
      const [game_available_location, setGame_available_location] = useState([]);
      const [locations, setLocations] = useState([]);


      const filteredResult = game_main_package.filter((item) => {
        return item.package_name.toLowerCase().includes(searchQuery.toLowerCase())
      });
      
   
      const handlePageChange = (selectedPage) => {
        setCurrentPage(selectedPage.selected);
      };

      useEffect(() => {
        setIsLoading(true);
        fetchGames();
        fetchLocations();
        getGameMainPackageList();
       
    }, []);

    const handleGameChange = (e) => {
        setSelectedGame(e.target.value);
  
      };

      const fetchLocations = async () => {
        try {
         
          const response = await axios.get(`${API_URL}/view-game-location`);
          setLocations(response.data.gameLocation);
        } catch (error) {
          console.error("Error fetching locations:", error);
        }
      };
      

      
      const handleGameAvailableLocationChange = (e) => {
        const selectedGameTypeId = e.target.value;
        setSelectedGameLocation(selectedGameTypeId);
      };

    const fetchGames = async () => {
        try {
          const response = await axios.get(`${API_URL}/view-game`);
          setGames(response.data.game);
        } catch (error) {
          console.error("Error fetching games:", error);
        }
      };
    
      function getGameMainPackageList()
      {
        
        axios.get(`${API_URL}/view-game-main-package`).then(res=>{
            if(res.data.status === 200){
                setGame_main_package(res.data.gameMainPackage); 
                //  scrollToRef.current.scrollIntoView({ behavior: "smooth" });            
            }     
            else if(res.data.status === 404){
                setGame_main_package([]);  
                }
                setIsLoading(false);
         });  
       
      }

      async function save(event)
      {
        
          event.preventDefault();
          setLoading(true);
          const formData = new FormData()
          formData.append('game_id', selectedGame);
          formData.append('package_name', package_name);
          formData.append('description', description);
          formData.append('created_by',  userContext.userDetails.id);
          
      
          await axios.post(`${API_URL}/save-game-main-package`, formData).then(res =>{
         
            Swal.fire({
              icon:"success",
              text:res.data.message
            }).then(function(){ 
                setLoading(false);        
                 resetData();
                 setErrorList([]);
                 getGameMainPackageList();
                 
          });
          }).catch(function(error) {
            setLoading(false);
            // if(error.response.status===422){         
            setErrorList(error.response.data.validate_err);
            // }
            // else{
              Swal.fire({
                text:error.response.data.message,
                icon:"error"
              })
            // }
          })
     }
    
    
     const resetData = () => {
      setSelectedGame('');
      setPackage_name('');
        };


        const deleteGameMainPackage= (e,id) =>{
            e.preventDefault();
            var buttonClicked = window.confirm("Are you sure you want to delete game main package?");
            if(buttonClicked == true){
               // const thisClicked = e.currentTarget;
               // thisClicked.innerText = "Deleting";
                axios.delete(`${API_URL}/delete-game-main-package/`+id).then(res => {
                 
              Swal.fire({
                      icon:"success",
                      text:res.data.message
                    }).then(function(){
                       // thisClicked.closest("tr").remove();  
                        
                  });
                   getGameMainPackageList();
                })
            }
            else
            {
                getGameMainPackageList();
            }
           
           }


 

    return(
        <div>
            <SideNav/>
            <TopBar/>

            {isLoading?
     <div className="loader-container" style ={{backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed",top: "0",left: "0",width: "100%",height: "100%",display: "flex",justifyContent: "center",alignItems: "center",zIndex: "9999"}}>
    <div class="d-flex justify-content-center">
  <div class="spinner-border" role="status">
  </div>
  </div>
</div>:null}


   <div class="right_panel position contact_section vh-100" id="right_panel">

<div class="main_title d-flex align-items-center">
    <h1><i class="bi bi-sticky"></i> Game Main Package</h1>
</div>

<div class="content_wrapper pt-0">
    <div class="vm_content_box_1">
        <div class="title">
            <h2>Create Game Main Package</h2>
        </div>
        <div class="content pt-3">  
                    
                        <div class="content pt-4 pb-4">
                            <div class="row">
                            <div class="col-md-3">
                            <div class="form-group">
                            <label for="game">Select Game:</label>
        <select  class="form-select" id="game" name="game" value={selectedGame} onChange={handleGameChange}>
          <option value="">Select a game</option>
          {games.map((game) => (
            <option key={game.id} value={game.id}>
              {game.name}
            </option>
          ))}
        </select>
                                       <span class="text-danger">{error_list.game_name}</span>
                                </div>
                                </div>

                                <div class=" col-md-3">
                            <div class="form-group">
                            <label for="game">Select Game Location:</label>
                            <select  class="form-select" id="game_available_location" name="game_available_location" value={selectedGameLocation} onChange={handleGameAvailableLocationChange}>
                            <option value="">Select game location</option>
                        {game_available_location.map((location) => (
                            <option key={location.id} value={location.id}>
                                {location.location_name}
                            </option>
                        ))}
        </select>
                            </div>
                        </div>
                                
                                <div className="col-md-3">
                                <div class="form-group">
                                <label for="package_name">Package Name</label>
                                <input type="text" class="form-control" name="package_name" id="package_name" value={package_name} placeholder="Package Name"
                                     onChange={(event) =>{ setPackage_name(event.target.value); }}/>
                                       <span class="text-danger">{error_list.package_name}</span>
                                
                            </div>
                            </div>
                            <div className="col-md-3">
                                <div class="form-group">
                                <label for="description">Description</label>
                                <input type="text" class="form-control" name="description" id="description" value={description} placeholder="Description"
                                     onChange={(event) =>{ setDescription(event.target.value); }}/>
                                       <span class="text-danger">{error_list.description}</span>
                                
                            </div>
                            </div>

                            </div>
                           
                           
                         
                    <button onClick={save} class="btn btn-sm btn_secondary text-white"><i class="bi bi-save me-2"></i> {loading?"Saving":"Save"}</button>
                            
                            </div>
            
        </div>
    </div>

    <div class="vm_content_box_1 mt-4">
        <div class="title">
            <h2>Manage Game Main Packages</h2>
        </div>

        <div class="content">
        <div class="row pt-3">
                          
                          <div class="col-md-9 form-group" >
                                  <div class="d-flex input_wrapper">
                                  <div ><label>Show   <select name="example_length" aria-controls="example" value={perPage} onChange={(e) => {setCurrentPage(0);setPerPage(Number(e.target.value))}}>
                                      <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option>
                                    </select>  entries</label>
                                    </div>
                              
                   
                                  </div>
                              </div>
  
                              <div class="col-md-3 form-group">
                                  <div class="d-flex input_wrapper">
                                      <div class="icon_wrapper">
                                          <i class="bi bi-search icon"></i>
                                      </div>
                                      <input class="form-control" name="searchQuery" id="searchQuery" placeholder="Search package name" type="text" 
                                      value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}}/>
                                  </div>
                              </div>
                          </div>

                         
                            <><table class="display dataTable dtr-inline" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                          <th>Game Name</th>
                                            <th>Package Name</th>
                                            <th>Description</th>
                                            <th class="text-end">Action</th>
                                        </tr>
                                    </thead>


                                    <tbody>
                                    {filteredResult.length == 0 ?
        <table class="display dataTable dtr-inline">
        <tbody>
          <tr>
            <div class="row" style={{margin: "10px -700px 10px 10px"}}>
                       <p  valign="top" class="odd" style={{ textAlign: "center" }} >No records found</p> 
                       </div>
          </tr>
        </tbody>
      </table>
      :    null }

                                        {filteredResult.slice((currentPage * perPage), ((currentPage * perPage) + perPage)).map((item, index) => 
                                            {
                                              const game = games.find(game => game.id === item.game_id) || {};
                                            
                                              return (
                                           <tr key={index}>
                                            
<td>
                          <p>{game ? game.name : 'Unknown'}</p>
                        </td>
                        <td>
                          <p>{item.package_name}</p>
                        </td>
                        <td>
                          <p>{item.description}</p>
                        </td>


                                                <td class="d-flex justify-content-end">

                                                    <Link to={`/edit-game-main-package/${item.id}`} class="btn btn-sm btn_secondary" data-bs-target="#createNewCustomre">
                                                        <i class="bi bi-pencil-square"></i> Edit</Link>

                                                    <button class="btn btn-sm btn_secondary" style={{ background: "red", color: "white", margin: "0px 0px 0px 10px" }}
                                                        onClick={(e) => deleteGameMainPackage(e, item.id)}><i class="bi bi-trash3"></i> Delete</button>
                                                </td>
                                            </tr>


);
})}
                                    </tbody>

                                    <tfoot>
                                        <tr>
                                        <th>Game Name</th>
                                        <th>Package Name</th>
                                        <th>Description</th>
                                            <th class="text-end">Action</th>
                                        </tr>
                                    </tfoot>
                                </table><div class="col-md-3" style={{ float: "left", padding: "20px 0px 0px 0px" }}>
                                        {filteredResult.length > 0 && `Showing 1 to ${Math.min(perPage, filteredResult.length)} of ${filteredResult.length} entries`}
                                    </div><div class="col-md-9" style={{ float: "right" }}>

                                        <ReactPaginate style={{ float: "right" }}
                                            previousLabel={"< Prev"}
                                            nextLabel={"Next >"}
                                            breakLabel={'...'}
                                            pageCount={Math.ceil(filteredResult.length / perPage)}
                                            onPageChange={handlePageChange}
                                            containerClassName={"pagination pagination-sm justify-content-center custom-pagination"} // Bootstrap pagination class
                                            disabledClassName={"disabled"}
                                            breakClassName={['page-item']}
                                            breakLinkClassName={'page-link'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item'}
                                            nextLinkClassName={'page-link'}
                                            activeClassName={['active']} />


                                    </div></>
                      

        </div>
    </div>
</div>

</div>



        </div>
    )
}

export default SettingGameMainPackage;